window.addEventListener(
  "load",
  (e) => {
    /* Сard-option-block.php
    --------------------------------------------- */
    if (document.querySelector(".card-option__titles")) {
      ScrollTrigger.create({
        trigger: ".card-option__titles",
        start: "top bottom",
        end: "bottom top",
        onEnter: () => {
          gsap.fromTo(
            ".card-option__titles",
            { y: 70, opacity: 0 },
            { y: 0, opacity: 1, duration: 2.3, ease: "power3.out" }
          );
        },
        once: true,
      });
      ScrollTrigger.create({
        trigger: ".card-option__block-item",
        onEnter: () => {
          gsap.fromTo(
            ".card-option__block-item:nth-child(1)",
            { x: -500, opacity: 0 },
            { x: 0, opacity: 1, duration: 2, ease: "power3.out" }
          );

          gsap.fromTo(
            ".card-option__block-item:nth-child(3)",
            { x: 500, opacity: 0 },
            { x: 0, opacity: 1, duration: 2, ease: "power3.out" }
          );
        },
        once: true,
      });
    }

    /* Tech-overview-block.php
    --------------------------------------------- */
    if (document.querySelector(".tech-overview__titles")) {
      ScrollTrigger.create({
        trigger: ".tech-overview__titles",
        onEnter: () => {
          gsap.fromTo(
            ".tech-overview__titles",
            { y: 70, opacity: 0 },
            { y: 0, opacity: 1, duration: 2.3, ease: "power3.out" }
          );
        },
        once: true,
      });

      ScrollTrigger.create({
        trigger: ".tech-overview__feature-item--description",
        onEnter: () => {
          gsap.fromTo(
            ".tech-overview__feature-item--description",
            { y: 50, opacity: 0 },
            { y: 0, opacity: 1, duration: 2.3, ease: "power3.out" }
          );
        },
        once: true,
      });
    }

    /* Banner-block.php
    --------------------------------------------- */
    if (document.querySelector(".banner__block-content--heading")) {
      ScrollTrigger.create({
        trigger: ".banner__block-content--heading",
        onEnter: () => {
          gsap.fromTo(
            ".banner__block-content--heading",
            { y: 30, opacity: 0 },
            { y: 0, opacity: 1, duration: 2, ease: "power3.out" }
          );
        },
        once: true,
      });

      ScrollTrigger.create({
        trigger: ".banner__block-content--description",
        onEnter: () => {
          gsap.fromTo(
            ".banner__block-content--description",
            { y: 30, opacity: 0, duration: 2.3 },
            { y: 0, opacity: 1, duration: 2.3, ease: "power3.out" }
          );
        },
        once: true,
      });
    }

    /* Timeline-block.php
    --------------------------------------------- */
    if (document.querySelector(".timeline__titles")) {
      ScrollTrigger.create({
        trigger: ".timeline__titles",
        onEnter: () => {
          gsap.fromTo(
            ".timeline__titles",
            { y: 50, opacity: 0, duration: 2.3 },
            { y: 0, opacity: 1, duration: 2.3, ease: "power3.out" }
          );
        },
        once: true,
      });

      ScrollTrigger.batch(".element-arrow-down", {
        onEnter: (batch) => {
          batch.forEach((el, index) => {
            const yValue = window.innerWidth < 767 ? 0 : -20;

            gsap.fromTo(
              el,
              { y: 120, opacity: 0 },
              {
                y: yValue,
                opacity: 1,
                duration: 1.8,
                ease: "power3.out",
                delay: index * 0.4,
              }
            );
          });
        },
        once: true,
      });
    }

    /* CTA-block.php
    --------------------------------------------- */
    if (document.querySelector(".cta__wrapper-titles")) {
      ScrollTrigger.create({
        trigger: ".cta__wrapper-titles h2",
        start: "top 85%",
        end: "bottom center",
        onEnter: () => {
          gsap
            .timeline()
            .fromTo(
              ".cta__wrapper-titles h2",
              { y: 30, opacity: 0 },
              { y: 0, opacity: 1, duration: 0.8, ease: "power3.out" }
            );
        },
        once: true,
      });

      ScrollTrigger.create({
        trigger: ".cta__wrapper-titles p",
        start: "top 85%",
        end: "bottom center",
        onEnter: () => {
          gsap
            .timeline()
            .fromTo(
              ".cta__wrapper-titles p",
              { y: 60, opacity: 0 },
              { y: 0, opacity: 1, duration: 1.2, ease: "power3.out" }
            );
        },
        once: true,
      });
    }

    if (document.querySelector(".video-interview")) {
      ScrollTrigger.create({
        trigger: ".video-interview",
        onEnter: () => {
          gsap.to(".video-interview-info", {
            right: 0,
            opacity: 1,
            ease: "power1",
          });
        },
        once: true,
      });
    }

    /* Hero-secondary-block.php
    --------------------------------------------- */
    if (document.querySelector(".hero-secondary__block-content")) {
      ScrollTrigger.create({
        trigger: ".hero-secondary__block-content",
        onEnter: () => {
          gsap.fromTo(
            ".hero-secondary__block-content",
            { y: 50, opacity: 0, duration: 2.3 },
            { y: 0, opacity: 1, duration: 2.3, ease: "power3.out" }
          );
        },
        once: true,
      });
    }

    /* Our-truck-block.php
    --------------------------------------------- */
    if (document.querySelector(".our-truck-types__titles")) {
      ScrollTrigger.create({
        trigger: ".our-truck-types__titles h2",
        start: "top 85%",
        end: "bottom center",
        onEnter: () => {
          gsap
            .timeline()
            .fromTo(
              ".our-truck-types__titles h2",
              { y: 30, opacity: 0 },
              { y: 0, opacity: 1, duration: 0.8, ease: "power3.out" }
            );
        },
        once: true,
      });

      ScrollTrigger.create({
        trigger: ".our-truck-types__titles p",
        start: "top 85%",
        end: "bottom center",
        onEnter: () => {
          gsap
            .timeline()
            .fromTo(
              ".our-truck-types__titles p",
              { y: 60, opacity: 0 },
              { y: 0, opacity: 1, duration: 1.2, ease: "power3.out" }
            );
        },
        once: true,
      });
    }

    /* Footer -> Parther-block.php
    --------------------------------------------- */
    if (document.querySelector(".partners")) {
      const mediaQueryPartner = window.matchMedia("(max-width: 767px)");

      function handleAnimation(mediaQuery) {
        if (!mediaQuery.matches) {
          ScrollTrigger.create({
            trigger: ".partners__wrapper",
            onEnter: () => {
              gsap.fromTo(
                ".partners__img:nth-child(1)",
                { x: -300, opacity: 0 },
                { x: 0, opacity: 1, duration: 2, ease: "power3.out" }
              );

              gsap.fromTo(
                ".partners__img:nth-child(3)",
                { x: 300, opacity: 0 },
                { x: 0, opacity: 1, duration: 2, ease: "power3.out" }
              );
            },
            once: true,
          });
        }
      }

      handleAnimation(mediaQueryPartner);
      mediaQueryPartner.addListener(handleAnimation);
    }
  },
  false
);

/************ Custom Animations ****************/
/*-------------------------------------------- */

/* timeline-block.php
--------------------------------------------- */

document.addEventListener("DOMContentLoaded", () => {
  const years = document.querySelectorAll(".year-list .year");
  const elements = document.querySelectorAll(
    ".timeline__block--right-element p"
  );
  const leftContainer = document.querySelector(
    ".timeline__block--left-container"
  );

  if (!leftContainer) return;

  const resetActiveClasses = () => {
    years.forEach((year) => year.classList.remove("active"));
  };

  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        resetActiveClasses();
        const index = Array.from(elements).indexOf(entry.target);
        if (index !== -1) {
          years[index].classList.add("active");
        }
      }
    });
  };

  const getRootMargin = () => {
    if (window.innerWidth >= 1500) {
      return "-35% 0px -35% 0px";
    } else {
      return "-40% 0px -40% 0px";
    }
  };

  const options = {
    root: null,
    threshold: 0,
    rootMargin: getRootMargin(),
  };

  const observer = new IntersectionObserver(handleIntersection, options);

  elements.forEach((element) => observer.observe(element));

  if (elements.length > 0) {
    observer.observe(elements[0]);
    years[0].classList.add("active");
  }
});
